export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_talent-attouna/artifacts/wnxfsj5d_image.png";

export const BRAND = {
  name: "Attouna Services",
  slogan: "Votre talent, notre priorité",
  phone: "514-232-4251",
  email: "info@attounaservices.ca",
  address: "9950 Place de l'Acadie, Montréal, Qc",
  cnesst: "AP-2604802",
  facebook: "https://www.facebook.com/profile.php?id=61590316706247",
};

// Sectors keys + image URL only — labels/descriptions come from i18n.
export const SECTOR_KEYS = ["entrepot", "paysagerie", "hotelier"];

export const SECTOR_IMAGES = {
  entrepot:
    "https://images.unsplash.com/photo-1687203920859-c87cb0955630?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
  paysagerie:
    "https://images.unsplash.com/photo-1627740283098-1c544d3a479d?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
  hotelier:
    "https://images.unsplash.com/photo-1621891336682-341097be99cd?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
};
